export class VsFileItem {
    id: string;
    fileName: string;
    folderId: number;
    size: number;
    path: string;
    link: string
    extention: string
    createdByUser: string;
    createdDate: Date;
    type: number; // 1: image, 2: audio, 3: video, 4: document, 5: other
    isFolder: boolean; // là folder
    idPath: string;
    displayPath: string;
    isHidden: boolean;  // Trường ẩn để đánh dấu có hiện xóa hay không
    //status: boolean;
    checked: boolean;
    isPrivated: boolean
    userId?: number

    constructor(init?: Partial<VsFileItem>) {
        Object.assign(this, init);
    }
}
